import { Navigate, useLocation, useParams, type RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Entrar from "@/pages/entrar/page";
import RecuperarSenha from "@/pages/recuperar-senha/page";
import NovaSenha from "@/pages/nova-senha/page";
import Evento from "@/pages/evento/page";
import Inscricao from "@/pages/inscricao/page";
import Ficha from "@/pages/inscricao/ficha/page";
import MinhasInscricoes from "@/pages/minhas-inscricoes/page";
import MinhaInscricao from "@/pages/minha-inscricao/page";
import MinhaFicha from "@/pages/minha-inscricao/ficha/page";
import MeuPerfil from "@/pages/meu-perfil/page";
import MeusEventos from "@/pages/meus-eventos/page";
import Convites from "@/pages/convites/page";
import Gerenciar from "@/pages/gerenciar/page";
import FichaImprimir from "@/pages/gerenciar/ficha-imprimir/page";
import ListaImprimir from "@/pages/gerenciar/lista-imprimir/page";
import ValidarPresencial from "@/pages/gerenciar/validar/page";
import AssistenteDirecao from "@/pages/gerenciar/assistente/page";
import CriancasDoEvento from "@/pages/gerenciar/criancas/page";
import AssistenteEvento from "@/pages/assistente-evento/page";
import EditarEvento from "@/pages/evento-editar/page";
import Ingresso from "@/pages/ingresso/page";
import Pedido from "@/pages/pedido/page";
import IngressoPedido from "@/pages/ingresso/pedido/page";
import MeusIngressos from "@/pages/meus-ingressos/page";
import MinhasFichas from "@/pages/minhas-fichas/page";
import MinhasRifas from "@/pages/minhas-rifas/page";
import CapaSorteio from "@/pages/minhas-rifas/capa/page";
import MeuTalao from "@/pages/meu-talao/page";
import BuscarTalao from "@/pages/buscar-talao/page";
import RifaNova from "@/pages/rifa-nova/page";
import RifaPronta from "@/pages/rifa-pronta/page";
import RifaImprimir from "@/pages/rifa-imprimir/page";
import Talao from "@/pages/talao/page";
import LojaPedido from "@/pages/loja/pedido/page";
import Carteira from "@/pages/carteira/page";
import LojaBarraca from "@/pages/loja/barraca/page";
import Fichas from "@/pages/fichas/page";
import CartazFichas from "@/pages/cartaz-fichas/page";
import Caixa from "@/pages/caixa/page";
import FechamentoCaixa from "@/pages/caixa/fechamento/page";
import CartazesImprimir from "@/pages/gerenciar/painel/equipe-dia/cartazes/page";
import RelatorioFechamento from "@/pages/gerenciar/painel/financeiro/relatorio/page";
import FichasImprimir from "@/pages/gerenciar/loja/fichas-imprimir/page";
import Presenca from "@/pages/presenca/page";
import EquipeConvite from "@/pages/equipe/page";
import Servir from "@/pages/servir/page";
import Portaria from "@/pages/portaria/page";
import Plataforma from "@/pages/plataforma/page";
import Agenda from "@/pages/agenda/page";
import Liturgia from "@/pages/liturgia/page";
import Oracao from "@/pages/oracao/page";
import Tribo from "@/pages/tribo/page";
import Conheca from "@/pages/conheca/page";
import Privacidade from "@/pages/privacidade/page";
import Termos from "@/pages/termos/page";
import ExcluirConta from "@/pages/excluir-conta/page";
import Instalar from "@/pages/instalar/page";
import NaoEncontrada from "@/pages/nao-encontrada/page";
import Criar from "@/pages/criar/page";
import CriarFormulario from "@/pages/criar/formulario/page";
import CriarOutro from "@/pages/criar/outro/page";
import CriarDivulgar from "@/pages/criar/divulgar/page";
import CriarIngresso from "@/pages/criar/ingresso/page";
import PortaRedirect from "@/pages/criar/components/PortaRedirect";
import Criancas from "@/pages/criancas/page";

function RedirectRifa({ sufixo }: { sufixo?: "pronta" | "imprimir" }) {
  const { rifaId } = useParams();
  const { search } = useLocation();
  const destino = sufixo ? `/sorteio/${rifaId}/${sufixo}` : "/sorteio/nova";
  return <Navigate to={`${destino}${search}`} replace />;
}

function RedirectLojaFichas() {
  const { slug } = useParams();
  return <Navigate to={`/e/${slug}/fichas`} replace />;
}

function RedirectDirecao() {
  const { eventoId } = useParams();
  return <Navigate to={`/gerenciar/${eventoId}?aba=equipes`} replace />;
}

function RedirectLoja() {
  const { eventoId } = useParams();
  return <Navigate to={`/gerenciar/${eventoId}?aba=loja`} replace />;
}

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/agenda", element: <Agenda /> },
      { path: "/liturgia", element: <Liturgia /> },
      { path: "/oracao", element: <Oracao /> },
      { path: "/tribo/:triboId", element: <Tribo /> },
      { path: "/como-funciona", element: <Navigate to="/conheca" replace /> },
      { path: "/conheca", element: <Conheca /> },
      { path: "/privacidade", element: <Privacidade /> },
      { path: "/termos", element: <Termos /> },
      { path: "/excluir-conta", element: <ExcluirConta /> },
      { path: "/e/:slug", element: <Evento /> },
      { path: "/e/:slug/fichas", element: <Fichas /> },
      { path: "/e/:slug/loja", element: <RedirectLojaFichas /> },
      { path: "/inscricao/:modalidadeId", element: <Inscricao /> },
      { path: "/minha-inscricao/:codigo", element: <MinhaInscricao /> },
      { path: "/minha-inscricao/:codigo/ficha", element: <MinhaFicha /> },
      { path: "/minhas-inscricoes", element: <MinhasInscricoes /> },
      { path: "/ingresso/:modalidadeId", element: <Ingresso /> },
      { path: "/pedido/:pedidoId", element: <Pedido /> },
      { path: "/pedido/c/:codigo", element: <IngressoPedido /> },
      { path: "/meus-ingressos", element: <MeusIngressos /> },
      { path: "/minhas-compras", element: <Navigate to="/meus-ingressos" replace /> },
      { path: "/minhas-fichas", element: <MinhasFichas /> },
      { path: "/minhas-rifas", element: <MinhasRifas /> },
      { path: "/minhas-rifas/:rifaId/capa", element: <CapaSorteio /> },
      { path: "/meu-talao/:rifaId", element: <MeuTalao /> },
      { path: "/meus-eventos", element: <MeusEventos /> },
      { path: "/convites", element: <Convites /> },
      { path: "/meu-perfil", element: <MeuPerfil /> },
      { path: "/gerenciar/:eventoId", element: <Gerenciar /> },
      { path: "/gerenciar/:eventoId/validar", element: <ValidarPresencial /> },
      { path: "/gerenciar/:eventoId/ficha/:inscricaoId/imprimir", element: <FichaImprimir /> },
      { path: "/gerenciar/:eventoId/fichas/imprimir", element: <FichaImprimir /> },
      { path: "/gerenciar/:eventoId/lista/imprimir", element: <ListaImprimir /> },
      { path: "/gerenciar/:eventoId/assistente", element: <AssistenteDirecao /> },
      { path: "/gerenciar/:eventoId/criancas", element: <CriancasDoEvento /> },
      { path: "/gerenciar/:eventoId/loja", element: <RedirectLoja /> },
      { path: "/gerenciar/:eventoId/direcao", element: <RedirectDirecao /> },
      { path: "/servir", element: <Servir /> },
    ],
  },
  { path: "/entrar", element: <Entrar /> },
  { path: "/recuperar-senha", element: <RecuperarSenha /> },
  { path: "/nova-senha/:token", element: <NovaSenha /> },
  { path: "/instalar", element: <Instalar /> },
  { path: "/criar", element: <Criar /> },
  { path: "/criar/formulario", element: <CriarFormulario /> },
  { path: "/criar/outro", element: <CriarOutro /> },
  { path: "/criar/divulgar", element: <CriarDivulgar /> },
  { path: "/criar/ingresso", element: <CriarIngresso /> },
  { path: "/criar/inscricoes", element: <PortaRedirect porta="inscricoes" /> },
  { path: "/criar/sorteio", element: <PortaRedirect porta="rifa" /> },
  { path: "/criar/rifa", element: <Navigate to="/criar/sorteio" replace /> },
  { path: "/inscricao/:modalidadeId/ficha", element: <Ficha /> },
  { path: "/evento/novo", element: <AssistenteEvento /> },
  { path: "/evento/:id/editar", element: <EditarEvento /> },
  { path: "/sorteio/nova", element: <RifaNova /> },
  { path: "/sorteio/:rifaId/pronta", element: <RifaPronta /> },
  { path: "/sorteio/:rifaId/imprimir", element: <RifaImprimir /> },
  { path: "/cartaz-fichas/:eventoId", element: <CartazFichas /> },
  { path: "/rifa/nova", element: <RedirectRifa /> },
  { path: "/rifa/:rifaId/pronta", element: <RedirectRifa sufixo="pronta" /> },
  { path: "/rifa/:rifaId/imprimir", element: <RedirectRifa sufixo="imprimir" /> },
  { path: "/t/:token", element: <Talao /> },
  { path: "/buscar-talao", element: <BuscarTalao /> },
  { path: "/loja/pedido/:codigo", element: <LojaPedido /> },
  { path: "/carteira/:codigo", element: <Carteira /> },
  { path: "/loja/barraca", element: <LojaBarraca /> },
  { path: "/caixa", element: <Caixa /> },
  { path: "/caixa/fechamento", element: <FechamentoCaixa /> },
  { path: "/gerenciar/:eventoId/cartazes", element: <CartazesImprimir /> },
  { path: "/gerenciar/:eventoId/relatorio-fechamento", element: <RelatorioFechamento /> },
  { path: "/gerenciar/:eventoId/loja/fichas-imprimir", element: <FichasImprimir /> },
  { path: "/presenca/:token", element: <Presenca /> },
  { path: "/criancas/:eventoId", element: <Criancas /> },
  { path: "/equipe/:token", element: <EquipeConvite /> },
  { path: "/portaria/:eventoId", element: <Portaria /> },
  { path: "/plataforma", element: <Plataforma /> },
  { path: "*", element: <NaoEncontrada /> },
];

export default routes;